import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Work from "./pages/Work";
import Projects from "./pages/Projects";
import Posts from "./pages/Posts";
import FirstPost from "./posts/FirstPost";
import DDS70 from "./pages/DDS70";
import LabLanding from "./LabLanding";
import "./App.css";

function Navbar({ darkMode, setDarkMode }) {
  const location = useLocation();
  return (
    <nav className="navbar rounded-navbar">
      <div className="navbar-content">
        <div className="navbar-links">
          <Link to="/" className={location.pathname === "/" ? "active" : ""}>
            <span className="nav-icon">
              {/* House icon */}
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path><path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path></svg>
            </span>
            Home
          </Link>
          <Link to="/work" className={location.pathname === "/work" ? "active" : ""}>
            <span className="nav-icon">
              {/* Briefcase icon */}
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path><rect width="20" height="14" x="2" y="6" rx="2"></rect></svg>
            </span>
            Work
          </Link>
          <Link to="/projects" className={location.pathname === "/projects" ? "active" : ""}>
            <span className="nav-icon">
              {/* Folder icon */}
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"></path></svg>
            </span>
            Projects
          </Link>
          <Link to="/posts" className={location.pathname === "/posts" ? "active" : ""}>
            <span className="nav-icon">
              {/* Book/Text icon */}
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"></path><path d="M8 11h8"></path><path d="M8 7h6"></path></svg>
            </span>
            Posts
          </Link>
          <a href="mailto:inisgood@gmail.com" className="say-hi">
            <span className="nav-icon">
              {/* Message/Chat icon */}
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path></svg>
            </span>
            Say Hi
          </a>
        </div>
        <button
          className="mode-toggle"
          onClick={() => setDarkMode((prev) => !prev)}
          aria-label="Toggle light/dark mode"
        >
          {darkMode ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3a7 7 0 0 0 9.79 9.79z"></path></svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
          )}
        </button>
      </div>
    </nav>
  );
}

export default function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem("darkMode");
    const isDark = saved ? JSON.parse(saved) : true;
    
    // Apply classes immediately to prevent flash
    document.body.classList.toggle("dark-bg", isDark);
    document.body.classList.toggle("light-bg", !isDark);
    document.documentElement.classList.toggle("dark-bg", isDark);
    document.documentElement.classList.toggle("light-bg", !isDark);
    
    return isDark;
  });
  const [showSplash, setShowSplash] = useState(() => {
    // Show splash by default, skip only for DDS70 or explicit skipIntro
    const currentPath = window.location.pathname;
    const params = new URLSearchParams(window.location.search);
    const forceIntro = params.get("intro") === "1";
    const skipIntro = params.get("skipIntro") === "1";
    
    if (skipIntro) return false;
    if (forceIntro) return true;
    // Skip only for DDS70 direct access
    return currentPath !== "/DDS70";
  });

  // Apply theme classes immediately on mount and when darkMode changes
  useEffect(() => {
    localStorage.setItem("darkMode", JSON.stringify(darkMode));
    document.body.classList.toggle("dark-bg", darkMode);
    document.body.classList.toggle("light-bg", !darkMode);
    // Also ensure html element classes are synced
    document.documentElement.classList.toggle("dark-bg", darkMode);
    document.documentElement.classList.toggle("light-bg", !darkMode);
  }, [darkMode]);

  // Developer tools protection
  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => {
      e.preventDefault();
      alert("Right-click is disabled.");
    };
    document.addEventListener("contextmenu", handleContextMenu);

    // Disable specific key combinations
    const handleKeyDown = (e) => {
      // F12
      if (e.keyCode === 123) {
        e.preventDefault();
        alert("Developer Tools disabled.");
      }
      // Ctrl+Shift+I or Ctrl+Shift+J or Ctrl+U
      if (
        (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J")) ||
        (e.ctrlKey && e.key === "u")
      ) {
        e.preventDefault();
        alert("Developer Tools disabled.");
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  if (showSplash) {
    return <LabLanding 
      darkMode={darkMode}
      onEnter={(destination) => {
        localStorage.setItem("splashSeen", "true");

        // Contact hotspot: open the mail client and stay in the lab.
        if (destination && destination.startsWith("mailto:")) {
          window.location.href = destination;
          return;
        }

        // Otherwise land on the current site's homepage. `destination` may
        // carry its own query (e.g. "/?tab=personal"); default to "/".
        // Setting the URL before the Router mounts ensures the right route
        // and tab are picked up, and drops the intro/skipIntro params.
        window.history.replaceState(null, "", destination || "/");
        setShowSplash(false);
      }} 
    />;
  }

  return (
    <Router>
      <Routes>
        {/* Home is full-bleed with its own header (split-persona layout) */}
        <Route path="/" element={<Home darkMode={darkMode} setDarkMode={setDarkMode} />} />
        {/* Inner pages keep the classic navbar + container */}
        <Route
          path="*"
          element={
            <>
              <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />
              <div className="container">
                <Routes>
                  <Route path="/work" element={<Work />} />
                  <Route path="/projects" element={<Projects />} />
                  <Route path="/posts" element={<Posts />} />
                  <Route path="/posts/first-post" element={<FirstPost />} />
                  <Route path="/DDS70" element={<DDS70 />} />
                </Routes>
              </div>
            </>
          }
        />
      </Routes>
    </Router>
  );
} 